<template>
  <div>
    <vxe-toolbar>
      <template v-slot:buttons>
        <el-dropdown @command="setSelectHandOverAt">
          <el-button type="default" size="mini">
            交货期在今天后<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="handOverAtSet of handOverAtSets"
              :key="handOverAtSet.day"
              :command="handOverAtSet"
              >{{ handOverAtSet.name }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown class="mgl10" @command="setSeleteSupplier">
          <el-button type="default" size="mini">
            {{ $t("action.selectSupplier") }}
            <i class="el-icon-caret-bottom el-icon--right" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="supplier of suppliers"
              :key="supplier.id"
              :command="supplier"
              >{{ supplier.name }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </vxe-toolbar>

    <vxe-table
      :data="purchases"
      :loading="loading"
      class="recordsTable"
      highlight-hover-row
      :scroll-y="{ enabled: false }"
    >
      <vxe-table-column field="images" :title="$t('product.images')" width="85">
        <template v-slot="{ row }">
          <thumbnail :images="row.images" />
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="serialNo"
        :title="$t('text.serialNo')"
        min-width="85"
      >
        <template v-slot="{ row }">
          <small v-if="row.hurry" class="red">
            ({{ $t("order.hurrySimple") }})
          </small>
          <span class="blue" v-if="row.orderCancelAt == null">
            {{ row.serialNo }}</span
          >
          <s class="grey" v-if="row.orderCancelAt != null">
            {{ row.serialNo }}
          </s>
          <div v-if="row.orderCancelAt != null" class="font10 grey-shallow">
            {{ $t("purchase.orderCancelAt") }}:{{ row.orderCancelAt }}
          </div>
          <div v-if="row.settleAt != null" class="green font10">
            {{ $t("purchase.settlement") }}:{{ row.settleAt }}
          </div>
          <div v-if="row.manualSettleAt != null" class="orange font10">
            {{ $t("purchase.manualSettle") }}:{{ row.manualSettleAt }}
          </div>
        </template>
      </vxe-table-column>

      <vxe-table-column
        field="productNo"
        :title="$t('product.productNo')"
        min-width="100"
      >
        <template v-slot="{ row }">
          {{ row.productNo }}
          <small
            v-if="row.customerProductNo != null && row.customerProductNo != ''"
          >
            ({{ row.customerProductNo }})
          </small>
          <div class="font10">
            {{ row.categoryName }}
            <span v-if="row.productBrand != null">/</span>
            {{ row.productBrand }}
          </div>
          <div class="font10">{{ row.color }} {{ row.size }}</div>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="remark"
        :title="$t('text.remark')"
        min-width="100"
      >
        <template v-slot="{ row }">
          <raw-html-limit-number
            :content="row.remark"
            :number="12"
            type="richText"
          />
          <div>
            <attribute :content="row.specJson" :number="12" />
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="quantity"
        :title="$t('text.quantity')"
        min-width="60"
      />
      <vxe-table-column
        field="supplierName"
        :title="$t('menu.suppliers')"
        min-width="140"
      >
        <template v-slot="{ row }">
          <el-select
            size="small"
            v-model="row.purchaseSupplierId"
            filterable
            clearable
            class="mgb5"
          >
            <el-option
              v-for="supplier in suppliers"
              :key="supplier.id"
              :label="supplier.name"
              :value="supplier.id"
            />
          </el-select>
          <el-input
            size="small"
            v-model="row.purchasePrice"
            :placeholder="$t('purchase.price')"
          ></el-input>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="handOverAt"
        :title="$t('text.handOverAt')"
        min-width="160"
      >
        <template v-slot="{ row }">
          <el-date-picker
            size="small"
            v-model="row.purchaseHandOverAt"
            type="date"
            style="width: 100%"
          />
          <div class="font10">
            {{ row.handOverAt }}
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="ownerName"
        :title="$t('text.handle')"
        min-width="110"
      >
        <template v-slot="{ row }">
          {{ row.handlerName }}
          <div class="font10">{{ row.handleDept }}</div>
        </template>
      </vxe-table-column>
      <vxe-table-column field="action" :title="$t('text.action')" width="50">
        <template v-slot="{ row, rowIndex }">
          <el-button type="text" @click="remove(row, rowIndex)" size="mini">
            {{ $t("text.remove") }}
          </el-button>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div class="right pd20">
      <el-button
        size="small"
        type="primary"
        :loading="submitDoing"
        @click="submit"
      >
        {{ $t("text.submit") }}
      </el-button>
      <el-button size="small" type="default" @click="close">
        {{ $t("text.close") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Util from "@/utils";
import { page } from "@/utils/mixins.js";
import Thumbnail from "@/components/Thumbnail";
import Supplier from "@/api/supplier.js";
import Purchase from "@/api/purchase.js";

export default {
  props: {
    purchases: Array,
  },
  mixins: [page],
  components: {
    Thumbnail,
  },
  data() {
    return {
      suppliers: [],
      Util: Util,
      handOverAtSets: [
        { day: 3, name: "3天" },
        { day: 5, name: "5天" },
        { day: 7, name: "7天" },
        { day: 10, name: "10天" },
        { day: 15, name: "15天" },
        { day: 20, name: "20天" },
        { day: 25, name: "25天" },
        { day: 30, name: "30天" },
      ],
      //
      submitDoing: false,
      loading: false,
    };
  },
  watch: {
    purchases() {
      this.getPurchasesNew();
    },
  },
  created() {
    const self = this;
    Supplier.findByTenantId().then(function (res) {
      if (res.status === 200) {
        self.suppliers = res.data;
      } else {
        self.sysError();
      }
      self.getPurchasesNew();
    });
  },
  methods: {
    getPurchasesNew() {
      const self = this;
      for (const p of self.purchases) {
        Vue.set(p, "purchaseSupplierId", p.supplierId);
        Vue.set(p, "purchasePrice", p.price);
        Vue.set(p, "purchaseHandOverAt", p.handOverAt);
      }
    },
    setSeleteSupplier(supplier) {
      for (const r of this.purchases) {
        r.purchaseSupplierId = supplier.id;
      }
    },
    setSelectHandOverAt(handOverAtSet) {
      for (const r of this.purchases) {
        r.purchaseHandOverAt = Util.nowAddDay(handOverAtSet.day);
      }
    },

    submit() {
      const self = this;
      if (self.purchases.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      for (const o of self.purchases) {
        if (o.purchaseSupplierId == null || o.purchaseHandOverAt == null) {
          self.$message({
            message: self.$t("prompt.purchaseMustFillSupplierHandOverAt"),
            type: "warning",
          });
          return;
        }
        if (o.purchasePrice === "") {
          obj.price = 0;
        }
        if (!Util.regexQuantity(o.purchasePrice)) {
          self.$message({
            message: self.$t("rules.regex", [self.$t("purchase.price")]),
            type: "warning",
          });
          return;
        }
      }
      const data = self.purchases.map((p) => {
        return {
          id: p.id,
          supplierId: p.purchaseSupplierId,
          supplierName: self.suppliers.find((s) => s.id == p.purchaseSupplierId)
            .name,
          price: p.purchasePrice,
          handOverAt: p.purchaseHandOverAt,
        };
      });
      self.submitDoing = true;
      Purchase.batchPlace(data).then(function (res) {
        self.submitDoing = false;
        if (res.status === 200) {
          self.sysResults(res.data, self.$t("prompt.placeSuccess"));
          self.$emit("updateData");
          self.$eventHub.$emit("purchasePlace");
        } else {
          self.sysError();
        }
      });
    },

    close() {
      this.$emit("close");
    },
    remove(row, rowIndex) {
      this.purchases.splice(rowIndex, 1);
    },
  },
};
</script>
